import cx from 'classnames';

import CloseIcon from '@material-ui/icons/Close';
import {
  Backdrop,
  Fade,
  IconButton,
  Modal,
  withStyles,
} from '@material-ui/core';

import style from './style.module.scss';

const ModalBackdrop = withStyles({
  root: {
    backgroundColor: 'rgba(45, 53, 67, 0.5)',
  },
})(Backdrop);

const CustomModal = ({
  open,
  onClose,
  children,
  closeButton,
  classes,
  styles,
  refs,
}) => {
  return (
    <Modal
      open={open}
      onClose={() => {
        onClose(false);
      }}
      className={cx(style.modal, classes?.modal)}
      closeAfterTransition
      BackdropComponent={ModalBackdrop}
      BackdropProps={{
        timeout: 300,
      }}
    >
      <Fade in={open} timeout={300}>
        <div
          ref={refs?.wrapper}
          style={styles?.wrapper}
          className={cx(style.wrapper, classes?.wrapper)}
        >
          {closeButton && (
            <IconButton
              className={style.close}
              size={'small'}
              edge={'end'}
              onClick={() => {
                onClose(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
          {children}
        </div>
      </Fade>
    </Modal>
  );
};

export default CustomModal;
